import { AxisBase } from './AxisBase';
import { IAxis } from './IAxis';

export class VerticalAxis extends AxisBase implements IAxis {
    constructor(height: number, private min: number, private max: number, ticksCount: number, container) {
        super('left', height, min, max, ticksCount, container);
        super.tickSize(40);
    }

    width(value?: number): number {
        const ratio = this.ratio() || 1;
        const width = this.space(value);
        this.group()
            .select('.axis-title')
            .attr('transform', 'translate(' + (-this.tickSize() - 5) * ratio + ',' + ((this.height() ? this.height() : 0) / 2) + ') rotate(-90)');
        return width;
    }

    height(): number {
        return this.size();
    }
}